export default {
    DATE: "YYYY-MM-DD",
    DATE_TIME: "YYYY-MM-DD HH:mm:ss",
    DATE_TIME_SHORT: "YYYY-MM-DD HH:mm"
}